<script lang="ts" setup>
import { memberConfig as config } from './configs/vowpath'
import MemberPageVowpath from './components/MemberPage.vowpath.vue'

const MemberPage = MemberPageVowpath
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <MemberPage :config="config" />
  </div>
</template>
